export const InviteSegmentEvents = {
  DrawerOpened: 'Renter Invite - Drawer Opened',
  FlowStarted: 'Renter Invite - Flow Started',
  PropertySelected: 'Renter Invite - Property Selected',
  EmailValidationCompleted: 'Renter Invite - Applicant Email Validation Completed',
  AdditionalApplicantChanged: 'Renter Invite - Additional Applicant Changed',
  LabelsResolved: 'Renter Invite - Labels Resolved/Loaded',
  ScreeningLabelSelected: 'Renter Invite - Screening Label Selected',
  RentCoverageSelected: 'Renter Invite - Customize Rent Coverage Selected',
  DepositCoverageSelected: 'Renter Invite - Customize Deposit Coverage Selected',
  Submit: 'Renter Invite - Submit',
  DrawerClosed: 'Renter Invite - Drawer Closed',
  ValidationErrorShown: 'Renter Invite - Validation Error Shown',
} as const;

type InviteSegmentKeys = keyof typeof InviteSegmentEvents;
export type InviteSegmentValues = (typeof InviteSegmentEvents)[InviteSegmentKeys];
